import React, { Component } from "react";




class SpinLoader extends Component {
  
  render () {
    return (
       <div style={{textAling: 'center', height: '7em', position: 'relative', top: '2.5em'}}>
        <div className="ld ld-spinner  ld-spin"></div>
       </div>
    )
  }
      

        
    
}

export default SpinLoader